import { render, staticRenderFns } from "./DefaultChart.vue?vue&type=template&id=112a5fe6&scoped=true&"
import script from "./DefaultChart.vue?vue&type=script&lang=js&"
export * from "./DefaultChart.vue?vue&type=script&lang=js&"
import style0 from "./DefaultChart.vue?vue&type=style&index=0&id=112a5fe6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112a5fe6",
  null
  
)

export default component.exports